<ng-container *ngIf="!!get">
    <tt-input ttLabel="company_name" [ttModel]="get.company_name" ttReadonly></tt-input>
    <tt-input ttLabel="user_name" [ttModel]="get.user_name" ttReadonly></tt-input>
    <tt-input ttLabel="dbname" [ttModel]="get.dbname" ttReadonly></tt-input>
    <tt-input ttLabel="webversion_url" [ttModel]="get.webversion_url" ttReadonly></tt-input>
    <tt-textarea ttLabel="webversion_info" [ttModel]="get.webversion_info" ttReadonly></tt-textarea>
    <ng-container *ngIf="get.show_last_updated === '1'">
        <tt-datetime ttLabel="last_updated" [ttModel]="get.last_updated" ttReadonly></tt-datetime>
        <tt-textarea ttLabel="last_updated_status" [ttModel]="get.last_updated_status" ttReadonly></tt-textarea>
    </ng-container>
    <tt-input ttLabel="dbstation_tt_client_version" [ttModel]="get.dbstation_tt_client_version" ttReadonly></tt-input>
    <tt-input ttLabel="tt_client_version" [ttModel]="clientVersion" ttReadonly></tt-input>
    <tt-input ttLabel="tt_servername" [ttModel]="serverName" ttReadonly></tt-input>
    <tt-button ttText="application_refresh" (ttClick)="forceReload()"></tt-button>
</ng-container>
